(function(){
  'use strict';

  var SELECTOR = '.scroll-bg';
  var ticking = false;

  function update(){
    var y = window.scrollY || window.pageYOffset || 0;
    var els = document.querySelectorAll(SELECTOR);
    if(!els || !els.length) return;

    els.forEach(function(el){
      var speed = parseFloat(el.getAttribute('data-speed')) || 0.25;

      // Tile genişliğini pencere genişliğine göre mod al:
      // (Görselin background-size genişliği tam bilinmediği için pratik ve akıcı bir sarma sağlar)
      var tileW = window.innerWidth || 1920;

      // Scroll'a bağlı yatay pozisyon
      var bgX = -((y * speed) % tileW);
      el.style.backgroundPosition = bgX + 'px 100%';
    });
  }

  function onScroll(){
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function(){
      update();
      ticking = false;
    });
  }

  function init(){
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);

    // Shopify Section olayları (AJAX yüklemeler için güvence)
    document.addEventListener('shopify:section:load', update);
    document.addEventListener('shopify:section:select', update);

    // DOM’a sonradan eklense bile yakalamak için:
    var mo = new MutationObserver(function(){
      if (document.querySelector(SELECTOR)) update();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive'){
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();